import { ACTION_TYPE_ATTRIBUTES, ACTION_TYPE_STOCK } from "../../../../../constants/actionTypes.js";
import StockSelectProducts from "./components/StockSelectProducts/StockSelectProducts.js";
import AttributesSelectProducts from "./components/AttributesSelectProducts/AttributesSelectProducts.js";
import CollectionModal from "../../../modals/CollectionModal/CollectionModal.js";
import { useAppSelector } from "../../../../hooks/redux.js";

const SelectProducts = () => {
  const actionData = useAppSelector((state) => state.action.actionData);

  return (
    <>
      {actionData.type === ACTION_TYPE_STOCK && <StockSelectProducts />}
      {actionData.type === ACTION_TYPE_ATTRIBUTES && <AttributesSelectProducts />}
      <CollectionModal />
    </>
  );
};

export default SelectProducts;